<order-search-modal>
<div id="{ props.modalId }" class="modal">
  <div class="modal__bg"></div>
  <div class="modal__content">
    <div class="modal__content_inner">
      <h2 class="heading-01 heading_search">検索条件設定</h2>
      <form class="" name="form01" action="" >
        <div class="container_input">
          <div class="wrap_input wrap_input-30">
            <label class="form-heading" for="orders_number">注文ID</label>
            <input class="text_input" type="text" name="order_id" id="order_id" placeholder="000000">
          </div><!--/.wrap_input-->
          <div class="wrap_input wrap_input-30">
            <label class="form-heading" for="service">サービス</label>
            <select name="service" id="service" class="sort-list">
              <option value="">全て</option>
              <option value="CROCOデスク">CROCOデスク</option>
            </select>
          </div><!--/.wrap_input-->
          <div class="wrap_input wrap_input-30">
            <label class="form-heading" for="status">ステータス</label>
            <select name="status" id="status" class="sort-list">
              <option value="">全て</option>
              <option value="pending-verification">注文確認</option>
              <option value="waiting-payment">決済待</option>
              <option value="active">稼働中</option>
              <option value="completed">完了</option>
              <option value="canceled">キャンセル・却下</option>
            </select>
          </div><!--/.wrap_input-->	
        </div><!--/.container_input-->
        
        <div class="container_input">
          <div class="wrap_input wrap_input-50">
            <label class="form-heading" for="application_date">お申込日</label>
            <div class="modal_input_container">
              <div class="modal_input_box">
                <input type="text" id="range_start" name="range_start" class="text_input input_calendar">
              </div><!--/.modal_input_box-->	
              <div class="modal_input-dash">〜</div>
              <div class="modal_input_box">
                <input type="text" id="range_end" name="range_end" class="text_input input_calendar">
              </div><!--/.modal_input_box-->	
            </div><!--/.modal_input_container-->
          </div><!--/.wrap_input-->	

          <!--
          <div class="wrap_input wrap_input-30">
            <label class="form-heading" for="person">担当者</label>
            <select name="staff" id="staff" class="sort-list">
              <option value="">全て</option>
              <option value="武者小路実篤">武者小路実篤</option>
              <option value="pod1">pod1</option>
              <option value="pod2">pod2</option>
              <option value="pod3">pod3</option>
              <option value="pod4">pod4</option>

            </select>
          </div>--><!--/.wrap_input-->		
        </div><!--/.container_input-->	
      </form>
      <div class="container_button">
        <button class="button button-clear" type="button" value="キャンセル" onclick={(e)=>clear(e)}>キャンセル</button>
        <button class="button button-primary button-primary-mini" type="button" value="検索" onclick={(e)=>search(e)}>検索</button>
      </div><!--/.container_button-->	
    </div><!--/.modal__content_inner-->
    <a class="btn_close_modal" onclick={(e)=>closeModal(e)}></a>
  </div><!--modal__content-->
</div><!--modal-->
<script>
  import di from "dependency-injection";
  export default {
    clear(e){
      $(`#${this.props.modalId} input[name]`).each((idx,el)=>{
        $(el).val('');
      });
      $(`#${this.props.modalId} select[name]`).each((idx,el)=>{
        $(el).val('');
      });
    },
    search(e) {
      let params = {page: 1};
      $(`#${this.props.modalId} input[name]`).each((idx,el)=>{
        params[$(el).attr('name')] = $(el).val();
      });
      $(`#${this.props.modalId} select[name]`).each((idx,el)=>{
        params[$(el).attr('name')] = $(el).val();
      });
      $(`#${this.props.modalId}`).hide();
      this.props.search(params);
    },
    closeModal(e){
      console.log(e);
      $(`#${this.props.modalId}`).hide();
    },
    onBeforeMount(){
      this.props.MenuApi.on('order:openSearchModal', ()=>{
        $(`#${this.props.modalId}`).show();
      });
    },
    onMounted() {
      $('input.input_calendar', this.root).flatpickr({locale: "ja"});
    }
  };
</script>
</order-search-modal>